import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { ServicioTecnicoRoutingModule } from './routing';
import { ListadoServicioTecnicoComponent } from './listado-servicio-tecnico/listado-servicio-tecnico.component';
import { MapaServicioTecnicoComponent } from './mapa-servicio-tecnico/mapa-servicio-tecnico.component';
import { FlotanteServicioTecnicoComponent } from './mapa-servicio-tecnico/flotante-servicio-tecnico/flotante-servicio-tecnico.component';
import { PedidosMaterialesComponent } from './pedidos-materiales/pedidos-materiales.component';
import { EventosGenericosModule } from '../eventos-genericos/module';
import { AsignarGenericoComponent } from '../administracion/eventos-tecnicos-genericos/asignar/asignar.component';
import { MapaFacilV2Component } from '../../../auxiliares/mapbox/mapa-facil-v2.component';

@NgModule({
  declarations: [
    ListadoServicioTecnicoComponent,
    MapaServicioTecnicoComponent,
    FlotanteServicioTecnicoComponent,
    PedidosMaterialesComponent,
  ],
  imports: [
    CommonModule,
    AuxiliaresModule,
    ServicioTecnicoRoutingModule,
    EventosGenericosModule,
    AsignarGenericoComponent,
    MapaFacilV2Component,
  ],
})
export class ServicioTecnicoModule {}
